import { RouteName } from '@/navigation/types';

/** The plan of a thematic meeting. */
export const meetingPlanPath = (meetingId: string): string =>
    `${RouteName.ThematicMeetings}/${meetingId}`;
